// extracted by mini-css-extract-plugin
module.exports = {"label":"remarks_label__2Nvuz"};